/** The GeometryInstance3D properties every drawn leaf reads. */
import { ShadowCastingSetting } from '../../../godot/rendering/rendering';
import { GODOT_DEFAULT_VISUAL_LAYERS } from '../../../godot/scene/visualLayers';
import { NO_VISIBILITY_RANGE } from '../../../godot/rendering/visibilityRange';
/** Godot's defaults (`visual_instance_3d.h:122-140`), which a scene that sets no value keeps. */
export const GEOMETRY_INSTANCE_DEFAULTS = Object.freeze({
    layers: GODOT_DEFAULT_VISUAL_LAYERS,
    transparency: 0,
    castShadow: ShadowCastingSetting.ON,
    visibilityRange: NO_VISIBILITY_RANGE,
    customAabb: null,
});
//# sourceMappingURL=types.js.map